// src/utils/imageSearchQuery.ts
import phrases from '../constants/imageSearchPhrases.json';

const POSSESSIVE_PLACEHOLDERS = /\b(someone|somebody|sb|something|sth|one)'s\b/g;

const OBJECT_PLACEHOLDERS = /\b(sb|sth|somebody|someone|something|oneself)\b/g;

// "to give up (smoking)" → "give up", "put up with sth" → "put up with",
// "pull someone's leg" → "pull leg", "the last straw" → "last straw"
export const normalizePhrase = (term: string): string => term
  .toLowerCase()
  .replace(/[’´`]/g, "'")
  .replace(/\(.*?\)/g, ' ')
  .replace(POSSESSIVE_PLACEHOLDERS, ' ')
  .replace(OBJECT_PLACEHOLDERS, ' ')
  .replace(/[^a-z\s'-]/g, ' ')
  .replace(/\s+/g, ' ')
  .trim()
  .replace(/^(to|a|an|the)\s+/, '');

// Hasło zamienione na opis sceny; brak wpisu w mapie → surowe hasło.
export const rewriteForImageSearch = (term: string): string => {
  const map = phrases as Record<string, string>;

  return map[normalizePhrase(term)] || term;
};
